<div
    class="select-input"
    (click)="toggleDropdown()"
    [class.disabled]="disabled"
    [class.focused]="focused">
    <!-- search select -->
    @if (isSearch()) {
    <input
        type="text"
        [(ngModel)]="searchQuery"
        [value]="searchQuery()"
        [placeholder]="searchPlaceholder()"
        [disabled]="disabled"
        [readonly]="readonly"
        [required]="required || isRequired()"
        (input)="showDropdown()"
        (input)="writeValue('')"
        class="search-input" />
    } @else {
    <!-- select -->
    <span
        class="selected-value"
        [ngClass]="{ 'form-style': isInForm() && (value == null || value === '') }">
        {{ selectPlaceholder }}
    </span>
    } @if (showRedAsterisk()) {
    <div class="custom-placeholder">
        <span class="name">{{ placeholder() }}</span>
        <span class="star">*</span>
    </div>
    }

    <floori-icon name="fl_chevron_down_o"></floori-icon>
</div>

@if (isOpened()) {
<div #dropdown class="select-dropdown" [class]="dropdownPosition()">
    <!-- search select -->
    @if (isSearch()) {
    <div class="search-items">
        @if (filteredItems().length > 0) {
        <ul class="items-list">
            @for (item of filteredItems(); track $index) {
            <li (click)="selectOption(item)" [class.selected]="item.value === value">
                @if (item.icon) {
                <img [src]="item.icon" alt="icon" loading="lazy" />
                } @else if (item.iconName) {
                <floori-icon [name]="item.iconName"></floori-icon>
                } @else if (item.iconEmoji) {
                <span class="emoji">{{ item.iconEmoji }}</span>
                }
                <div class="item-text">
                    @if (showValue()) {
                    <span class="item-value">{{ item.value }}</span>
                    } @if (showDescription()) {
                    <span class="item-value">{{ item.description }}</span>
                    }

                    <span class="item-label"> {{ item.label }}</span>
                </div>
            </li>
            }
        </ul>
        } @else {
        <p class="items-list no-results">{{ noResultMessage() }}</p>
        }
    </div>
    }
    <!-- select -->
    @else { @if (multiselect() && showSelectAllActions()) {
    <div class="multiselect-actions">
        <button
            floori-button
            class="outline small"
            (click)="selectAll(); $event.stopPropagation()"
            [disabled]="isSelectAllDisabled()"
            type="button">
            {{ "common.selectAll" | flTranslate }}
        </button>
        <button
            floori-button
            class="outline small"
            (click)="unselectAll(); $event.stopPropagation()"
            type="button">
            {{ "common.unselectAll" | flTranslate }}
        </button>
    </div>
    } @for (option of orderedSelectOptions(); track option.value) {
    <!-- multiselect dropdown -->
    @if (multiselect()) { @let isDisabled = isOptionDisabled(option);
    <div
        class="select-item"
        [class.selected]="isMultiselectChecked(option)"
        [class.disabled]="isDisabled">
        <floori-checkbox
            class="align-checkbox-end"
            (checkedChanged)="handleMultiselectChange($event, option)"
            [checked]="isMultiselectChecked(option)"
            [disabled]="isDisabled">
            <div class="multiselect-item-content">
                @if (option.icon) {
                <img [src]="option.icon" alt="icon" loading="lazy" />
                } @else if (option.iconName) {
                <floori-icon [name]="option.iconName"></floori-icon>
                } @else if (option.iconEmoji) {
                <span class="emoji">{{ option.iconEmoji }}</span>
                }
                <span class="multiselect-label">{{ option.label }}</span>
            </div>
        </floori-checkbox>
    </div>
    } @else {
    <!-- single select dropdown -->
    <div
        class="select-item"
        [class.selected]="option.value === value"
        (click)="selectOption(option)">
        @if (option.icon) {
        <img [src]="option.icon" alt="icon" loading="lazy" />
        } @else if (option.iconName) {
        <floori-icon [name]="option.iconName"></floori-icon>
        } @else if (option.iconEmoji) {
        <span class="emoji">{{ option.iconEmoji }}</span>
        }
        <span class="select-item-content">{{ option.label }}</span>
    </div>
    } } }
</div>
}
